import { PlanActionMode } from '@aibees/shared/definition';
import { ButtonProps } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

export interface ButtonModeConfig {
  sx?: SxProps<Theme>;
  props?: Partial<ButtonProps>;
}

export function getButtonPropsForMode(
  actionMode: PlanActionMode | null,
  currentPlanIsFree: boolean,
  isMostPopular: boolean | undefined
): ButtonModeConfig {
  if (isMostPopular) {
    return {
      props: {
        variant: 'contained',
      },
    };
  }
  switch (actionMode) {
    case PlanActionMode.UPGRADE:
      return {
        props: {
          variant: 'contained',
          color: 'primary',
        },
      };

    case PlanActionMode.DOWNGRADE_PAID:
      return {
        props: {
          variant: 'contained',
        },
      };

    case PlanActionMode.DOWNGRADE_FREE:
      return {
        props: {
          variant: 'outlined',
        },
      };

    case PlanActionMode.CANCEL_DOWNGRADE:
      return {
        props: {
          variant: 'contained',
          color: 'warning',
        },
      };

    case null:
      if (currentPlanIsFree) {
        return {
          props: {
            variant: 'contained',
          },
          sx: {
            backgroundColor: 'common.white',
            color: 'grey.600',
            border: '1px solid',
            borderColor: 'grey.400',
          },
        };
      } else {
        // Current paid plan
        return {
          props: {
            variant: 'contained',
          },
          sx: {
            backgroundColor: 'primary.200',
            color: 'primary.50',
          },
        };
      }

    default:
      // Fallback to default styling
      return {
        sx: {
          backgroundColor: 'common.white',
          color: 'primary.500',
          '&:hover': {
            backgroundColor: 'primary.100',
          },
        },
      };
  }
}
